import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 32px;
  text-align: center;
  min-height: 400px;

  @media (max-width: 767px) {
    padding: 48px 24px;
    min-height: 300px;
  }
`

export const IconWrapper = styled.div`
  margin-bottom: 32px;
  color: #cccccc;

  @media (max-width: 767px) {
    margin-bottom: 24px;
  }
`

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 16px 0;
  line-height: 1.3;

  @media (max-width: 767px) {
    font-size: 20px;
    margin-bottom: 12px;
  }
`

export const Description = styled.p`
  font-size: 16px;
  color: #666666;
  margin: 0 0 32px 0;
  max-width: 400px;
  line-height: 1.5;

  @media (max-width: 767px) {
    font-size: 14px;
    margin-bottom: 24px;
    max-width: 300px;
  }
`
